import { apiPaths } from 'app/services/api';
import React from 'react';
import { MOBILE_REGEX } from '../../smart-kit/Form/gridFormUtils';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const provinces = [
  {
    id: 1,
    name: 'آذربایجان شرقی',
    slug: 'آذربایجان-شرقی',
    tel_prefix: '041',
  },
  {
    id: 2,
    name: 'آذربایجان غربی',
    slug: 'آذربایجان-غربی',
    tel_prefix: '044',
  },
  // {
  //   id: 3,
  //   name: "اردبیل",
  //   slug: "اردبیل",
  //   tel_prefix: "045",
  // },
  {
    id: 4,
    name: 'اصفهان',
    slug: 'اصفهان',
    tel_prefix: '031',
  },
  {
    id: 5,
    name: 'البرز',
    slug: 'البرز',
    tel_prefix: '026',
  },
  // {
  //   id: 6,
  //   name: "ایلام",
  //   slug: "ایلام",
  //   tel_prefix: "084",
  // },
  // {
  //   id: 7,
  //   name: "بوشهر",
  //   slug: "بوشهر",
  //   tel_prefix: "077",
  // },
  {
    id: 8,
    name: 'تهران',
    slug: 'تهران',
    tel_prefix: '021',
  },
  {
    id: 9,
    name: 'چهارمحال و بختیاری',
    slug: 'چهارمحال-بختیاری',
    tel_prefix: '038',
  },
  // {
  //   id: 10,
  //   name: "خراسان جنوبی",
  //   slug: "خراسان-جنوبی",
  //   tel_prefix: "056",
  // },
  {
    id: 11,
    name: 'خراسان رضوی',
    slug: 'خراسان-رضوی',
    tel_prefix: '051',
  },
  // {
  //   id: 12,
  //   name: "خراسان شمالی",
  //   slug: "خراسان-شمالی",
  //   tel_prefix: "058",
  // },
  {
    id: 13,
    name: 'خوزستان',
    slug: 'خوزستان',
    tel_prefix: '061',
  },
  {
    id: 14,
    name: 'زنجان',
    slug: 'زنجان',
    tel_prefix: '024',
  },
  // {
  //   id: 15,
  //   name: "سمنان",
  //   slug: "سمنان",
  //   tel_prefix: "023",
  // },
  {
    id: 16,
    name: 'سیستان و بلوچستان',
    slug: 'سیستان-بلوچستان',
    tel_prefix: '054',
  },
  {
    id: 17,
    name: 'فارس',
    slug: 'فارس',
    tel_prefix: '071',
  },
  // {
  //   id: 18,
  //   name: "قزوین",
  //   slug: "قزوین",
  //   tel_prefix: "028",
  // },
  {
    id: 19,
    name: 'قم',
    slug: 'قم',
    tel_prefix: '025',
  },
  {
    id: 20,
    name: 'کردستان',
    slug: 'کردستان',
    tel_prefix: '087',
  },
  {
    id: 21,
    name: 'کرمان',
    slug: 'کرمان',
    tel_prefix: '034',
  },
  {
    id: 22,
    name: 'کرمانشاه',
    slug: 'کرمانشاه',
    tel_prefix: '083',
  },
  // {
  //   id: 23,
  //   name: "کهگیلویه و بویراحمد",
  //   slug: "کهگیلویه-بویراحمد",
  //   tel_prefix: "074",
  // },
  // {
  //   id: 24,
  //   name: "گلستان",
  //   slug: "گلستان",
  //   tel_prefix: "017",
  // },
  // {
  //   id: 25,
  //   name: "لرستان",
  //   slug: "لرستان",
  //   tel_prefix: "066",
  // },
  {
    id: 26,
    name: 'گیلان',
    slug: 'گیلان',
    tel_prefix: '013',
  },
  {
    id: 27,
    name: 'مازندران',
    slug: 'مازندران',
    tel_prefix: '011',
  },
  {
    id: 28,
    name: 'مرکزی',
    slug: 'مرکزی',
    tel_prefix: '086',
  },
  // {
  //   id: 29,
  //   name: "هرمزگان",
  //   slug: "هرمزگان",
  //   tel_prefix: "076",
  // },
  // {
  //   id: 30,
  //   name: "همدان",
  //   slug: "همدان",
  //   tel_prefix: "081",
  // },
  {
    id: 31,
    name: 'یزد',
    slug: 'یزد',
    tel_prefix: '035',
  },
  // {
  //   id: 32,
  //   name: "سایر",
  //   slug: "سایر",
  //   // tel_prefix: "035",
  // },
];

const fields = [
  // main
  {
    label: 'Mobile Number',
    type: 'number',
    key: 'mobile_number',
    validation: { required: true, pattern: { value: MOBILE_REGEX, message: 'not a valid mobile' } },
  },
  // { label: 'Gender', key: 'gender', type: 'radio', items: [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }, { value: 'other', label: 'Other' }], validation: { required: false } },
  {
    label: 'Name',
    group: 'Name',
    groupIndex: 0,
    key: 'first_name',
    validation: { required: true },
  },
  {
    label: 'Last Name',
    group: 'Name',
    groupIndex: 1,
    key: 'last_name',
    validation: { required: true },
  },
  {
    label: 'City',
    key: 'city',
    validation: { required: false },
    type: 'select',
    items: provinces.map((province) => ({
      value: province.slug,
      label: province.name,
    })),
  },
  {
    label: 'Profile Pic',
    key: 'profile_pic',
    type: 'image',
    purpose: 'profile_pic',
    validation: { required: false },
  },
  // {label: 'National Card Pic', key:'national_card_pic', type:'image', purpose: 'national_card_pic', validation: {required: false}},

  // { label: 'Birth Date', key: 'birth_date', type: 'date', validation: { required: false } },
];
const AgentForm = () => {
  return <CrudGridForm path={apiPaths.AGENTS} name="User" entityName={'agents'} fields={fields} />;
};

export default AgentForm;
